export var MuiAvatar = {
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                fontSize: 18,
                fontWeight: 600,
                width: theme.spacing(6),
                height: theme.spacing(6),
            });
        },
    },
};
